import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { isInstalled } from "../utilities/utilities";
import "../styles/mobile-download-banner.scss";

export function MobileDownloadBanner({ onDismiss }) {
  const [isVisible, setIsVisible] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const isMobile = useSelector((store) => store.page.isMobile);
  const installed = isInstalled();

  useEffect(() => {
    // Check if banner should be visible
    const bannerDismissed = localStorage.getItem("hgs-banner-dismissed");
    
    // Only show on mobile devices, when not already installed, and not previously dismissed
    if (isMobile && !installed && !bannerDismissed) {
      setIsVisible(true);
    }

    // Listen for beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the default browser install prompt
      e.preventDefault();
      // Store the event for later use
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, [isMobile, installed]);

  const handleDownload = async () => {
    if (deferredPrompt) {
      // Show the browser's install prompt
      deferredPrompt.prompt();
      
      // Wait for the user to respond to the prompt
      const { outcome } = await deferredPrompt.userChoice;
      
      if (outcome === 'accepted') {
        setIsVisible(false);
        if (onDismiss) {
          onDismiss();
        }
      }
      
      // Clear the deferredPrompt
      setDeferredPrompt(null);
    } else {
      // Fallback for browsers that don't support beforeinstallprompt
      // or if the event hasn't fired yet
      showInstallInstructions();
    }
  };

  const showInstallInstructions = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);
    
    let instructions = "";
    
    if (isIOS) {
      instructions = "To install this app on your iPhone/iPad, tap the Share button and then 'Add to Home Screen'.";
    } else if (isAndroid) {
      instructions = "To install this app on your Android device, tap the menu button in your browser and select 'Add to Home screen' or 'Install app'.";
    } else {
      instructions = "To install this app, look for the install option in your browser's menu.";
    }
    
    alert(instructions);
  };

  const handleDismiss = () => {
    setIsVisible(false);
    // Remember that user dismissed the banner
    localStorage.setItem("hgs-banner-dismissed", "true");
    // Call parent's onDismiss if provided
    if (onDismiss) {
      onDismiss();
    }
  };

  // Don't render if not visible
  if (!isVisible) {
    return null;
  }

  return (
    <div className="mobile-download-banner">
      <div className="banner-content">
        <div className="banner-icon" aria-hidden="true">
          <i className="fa fa-mobile"></i>
        </div>
        <div className="banner-text">
          <div className="banner-title">Download HGS Mobile App</div>
          <div className="banner-subtitle">Get the best mobile experience</div>
        </div>
        <div className="banner-actions">
          <button className="download-btn" onClick={handleDownload}>
            <i className="fa fa-download"></i>
            Download
          </button>
          <button className="close-btn" onClick={handleDismiss} aria-label="Close banner">
            ×
          </button>
        </div>
      </div>
    </div>
  );
}
